import { useScrollFadeIn, staggerStyle } from "@/hooks/useScrollFadeIn";

const courses = [
  { time: "60分", price: "¥25,000" },
  { time: "90分", price: "¥30,000" },
  { time: "120分", price: "¥35,000" },
  { time: "150分", price: "¥45,000" },
  { time: "180分", price: "¥55,000" },
  { time: "210分", price: "¥65,000" },
  { time: "240分", price: "¥75,000" },
];

const options = [
  { name: "乳首舐め", price: "¥2,000" },
  { name: "聖水", price: "¥3,000" },
];

const costumes = [
  { name: "ボンデージ", price: "¥1,000" },
  { name: "その他衣装", price: "¥1,000" },
];

const areas = [
  { name: "新宿・渋谷・日暮里・鶯谷", fee: "無料", freeColor: true },
  { name: "池袋・五反田・錦糸町", fee: "+¥1,000", freeColor: false },
  { name: "アルファイン", fee: "+¥3,000", freeColor: false },
  { name: "その他エリア", fee: "+¥1,000〜", freeColor: false },
];

const talkCourse = {
  price: "¥20,000",
  duration: "２時間",
  catchCopy: "まずはゆっくり話してみたい",
  subCopy: "プレイ抜きで安心して過ごしたい",
  description:
    "日常のこと、心のこと、性のこと。誰にも言えなかった気持ちを、安心して言葉にできる時間を大切にしています。プレイ前に一度お話してみたい方にもおすすめです。",
  note: "",
  details: [
    "お道具のご用意・セクシャルなプレイは御座いません。",
    "静かな空間で、無理なくお話をする時間です。",
    "落ち着けるラブホ・ラウンジ等をご用意ください。",
  ],
  disclaimer: "医療行為・治療を目的としたものではありません。",
};

export default function PriceSection() {
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>();
  const { ref: bodyRef, style: bodyStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.1 });
  const { ref: talkRef, style: talkStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.15 });
  const { ref: desktopRef, visible } = useScrollFadeIn<HTMLDivElement>({ delay: 0.1 });

  return (
    <section id="price" className="py-14 md:py-14 bg-stone-50">
      <div className="max-w-5xl mx-auto px-5 md:px-10">

        {/* Heading */}
        <div ref={headRef} style={headStyle} className="text-center mb-4 md:mb-6">
          <h2 className="font-en text-3xl md:text-4xl font-normal text-stone-800 tracking-widest">
            PRICE
          </h2>
          <div className="w-12 md:w-14 h-0.5 bg-rose-600 mx-auto mt-3 md:mt-4 mb-3 md:mb-4"></div>
          <p className="text-sm md:text-base text-stone-600 leading-loose tracking-wide mx-auto md:whitespace-nowrap"><strong className="text-stone-800 font-medium">完全出張制</strong>のプライベートサービス</p>
          <p className="mt-2 text-xs md:text-sm text-stone-400 tracking-wider">
            ※ 場所代・ホテル代はお客様ご負担となります
          </p>
        </div>

        {/* ===== MOBILE LAYOUT ===== */}
        <div ref={bodyRef} style={bodyStyle} className="block lg:hidden space-y-3">

          {/* Course カード */}
          <div className="bg-stone-50 border border-stone-200 px-4 py-5 rounded-lg">
            <h3 className="text-xs tracking-[0.35em] text-rose-900 uppercase mb-4 flex items-center gap-2 font-semibold">
              <span className="flex-1 h-px bg-rose-2000/60"></span>
              Course
              <span className="flex-1 h-px bg-rose-2000/60"></span>
            </h3>
            <div className="grid grid-cols-2 gap-x-5">
              {courses.map((c, i) => (
                <div key={i} className="flex items-center justify-between py-2.5 border-b border-stone-200 last:border-b-0">
                  <span className="text-sm text-stone-600 tracking-wide">{c.time}</span>
                  <span className="text-sm text-stone-900 font-semibold tracking-wide">{c.price}</span>
                </div>
              ))}
            </div>
            <div className="mt-3 pt-3 border-t border-stone-200 flex flex-col gap-1">
              <p className="text-xs text-stone-500">※場所代・ホテル代はお客様負担</p>
              <p className="text-xs text-stone-500">※以降は30分ごとに¥10,000追加チャージ</p>
            </div>
          </div>

          {/* Options + Costume 横並び */}
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-stone-50 border border-stone-200 px-4 py-4 rounded-lg">
              <h3 className="text-xs tracking-[0.3em] text-rose-900 uppercase mb-3 text-center font-semibold">Options</h3>
              {options.map((o, i) => (
                <div key={i} className="flex items-center justify-between py-2.5 border-b border-stone-200 last:border-b-0">
                  <span className="text-sm text-stone-600">{o.name}</span>
                  <span className="text-sm text-stone-900 font-semibold">{o.price}</span>
                </div>
              ))}
            </div>
            <div className="bg-stone-50 border border-stone-200 px-4 py-4 rounded-lg">
              <h3 className="text-xs tracking-[0.3em] text-rose-900 uppercase mb-3 text-center font-semibold">Costume</h3>
              {costumes.map((c, i) => (
                <div key={i} className="flex items-center justify-between py-2.5 border-b border-stone-200 last:border-b-0">
                  <span className="text-sm text-stone-600">{c.name}</span>
                  <span className="text-sm text-stone-900 font-semibold">{c.price}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Area カード */}
          <div className="bg-stone-50 border border-stone-200 px-4 py-5 rounded-lg">
            <h3 className="text-xs tracking-[0.35em] text-rose-900 uppercase mb-4 flex items-center gap-2 font-semibold">
              <span className="flex-1 h-px bg-rose-2000/60"></span>
              Area（交通費）
              <span className="flex-1 h-px bg-rose-2000/60"></span>
            </h3>
            <div className="space-y-0">
              {areas.map((a, i) => (
                <div key={i} className="flex items-center justify-between py-2.5 border-b border-stone-200 last:border-b-0">
                  <span className="text-sm text-stone-600">{a.name}</span>
                  <span className={`text-sm font-semibold ${a.freeColor ? "text-emerald-600" : "text-stone-700"}`}>
                    {a.fee}
                  </span>
                </div>
              ))}
            </div>
            <p className="text-xs text-stone-500 mt-3">※その他エリアはお気軽にご相談ください</p>
          </div>

          {/* おはなしコース カード (mobile) — SPECIAL */}
          <div data-section="talk-course" className="bg-gradient-to-br from-rose-50 to-white border-2 border-rose-200 px-4 py-5 rounded-xl">
            <div className="flex items-center justify-between mb-3">
              <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-amber-400 to-yellow-500 text-white text-[10px] font-semibold tracking-[0.2em] px-3 py-1 rounded-full whitespace-nowrap">
                <i className="ri-vip-crown-2-fill text-[11px] leading-none"></i>
                SPECIAL
              </span>
              <span className="font-en text-[11px] tracking-[0.25em] text-amber-600 uppercase leading-none">Talk Course</span>
            </div>
            <p className="text-base font-semibold text-stone-800 tracking-wide mb-2 whitespace-nowrap">おはなしコース <span className="text-xs font-normal text-stone-500">（カウンセリングセッション）</span></p>
            <p className="text-sm text-stone-600 leading-relaxed mb-4">{talkCourse.description}</p>
            <div className="flex items-center justify-between bg-white border border-rose-100 rounded-lg px-4 py-3">
              <span className="text-xs text-stone-500 tracking-wide">{talkCourse.duration}</span>
              <span className="text-lg text-stone-900 font-semibold tracking-wide">{talkCourse.price}</span>
            </div>
            <div className="mt-4 space-y-1.5">
              {talkCourse.details.map((d, i) => (
                <p key={i} className="text-[11px] text-stone-500 leading-relaxed whitespace-nowrap">・{d}</p>
              ))}
            </div>
            <p className="text-[11px] text-stone-400 mt-4 pt-3 border-t border-rose-100">{talkCourse.disclaimer}</p>
          </div>

        </div>

        {/* ===== DESKTOP LAYOUT ===== */}
        <div ref={desktopRef} className="hidden lg:flex flex-col gap-4">

          {/* 既存コース — 5カラムグリッド */}
          <div className="grid grid-cols-5 gap-5 items-start" style={staggerStyle(visible, 0, 0.1, 0.12)}>

            {/* LEFT: Course カード — 2/5 幅 */}
            <div className="col-span-2 bg-stone-50 border border-stone-100 px-5 py-5">
              <h3 className="text-[10px] tracking-[0.35em] text-rose-900 uppercase mb-4 flex items-center gap-2">
                <span className="flex-1 h-px bg-rose-200"></span>
                Course
                <span className="flex-1 h-px bg-rose-200"></span>
              </h3>
              <div className="space-y-0">
                {courses.map((c, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 border-b border-stone-100">
                    <span className="text-sm text-stone-500 tracking-wider">{c.time}</span>
                    <span className="text-sm text-stone-800 font-medium tracking-wider">{c.price}</span>
                  </div>
                ))}
              </div>
              <div className="mt-3 pt-2.5 border-t border-stone-100 space-y-0.5">
                <p className="text-[10px] text-stone-400 leading-relaxed">※場所代・ホテル代はお客様負担となります。</p>
                <p className="text-[10px] text-stone-400 leading-relaxed">※以降は30分ごとに¥10,000追加チャージ</p>
              </div>
            </div>

            {/* RIGHT: Options / Costume / Area */}
            <div className="col-span-3 flex flex-col gap-3" style={staggerStyle(visible, 1, 0.1, 0.12)}>

              {/* Options + Costume 横並びカード */}
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-stone-50 border border-stone-100 px-4 py-4">
                  <h3 className="text-[10px] tracking-[0.35em] text-rose-900 uppercase mb-3 flex items-center gap-2">
                    <span className="flex-1 h-px bg-rose-200"></span>
                    Options
                    <span className="flex-1 h-px bg-rose-200"></span>
                  </h3>
                  <div className="space-y-0">
                    {options.map((o, i) => (
                      <div key={i} className="flex items-center justify-between py-2.5 border-b border-stone-100">
                        <span className="text-sm text-stone-500">{o.name}</span>
                        <span className="text-sm text-stone-800 font-medium tracking-wider">{o.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="bg-stone-50 border border-stone-100 px-4 py-4">
                  <h3 className="text-[10px] tracking-[0.35em] text-rose-900 uppercase mb-3 flex items-center gap-2">
                    <span className="flex-1 h-px bg-rose-200"></span>
                    Costume
                    <span className="flex-1 h-px bg-rose-200"></span>
                  </h3>
                  <div className="space-y-0">
                    {costumes.map((c, i) => (
                      <div key={i} className="flex items-center justify-between py-2.5 border-b border-stone-100">
                        <span className="text-sm text-stone-500">{c.name}</span>
                        <span className="text-sm text-stone-800 font-medium tracking-wider">{c.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Area カード — 全幅 */}
              <div className="bg-stone-50 border border-stone-100 px-4 py-4">
                <h3 className="text-[10px] tracking-[0.35em] text-rose-900 uppercase mb-3 flex items-center gap-2">
                  <span className="flex-1 h-px bg-rose-200"></span>
                  Area（交通費）
                  <span className="flex-1 h-px bg-rose-200"></span>
                </h3>
                <div className="grid grid-cols-2 gap-x-6 gap-y-0">
                  <div className="flex items-center justify-between py-2.5 border-b border-stone-100">
                    <span className="text-sm text-stone-500">新宿・渋谷・日暮里・鶯谷</span>
                    <span className="text-sm text-emerald-600 font-medium whitespace-nowrap">無料</span>
                  </div>
                  <div className="flex items-center justify-between py-2.5 border-b border-stone-100">
                    <span className="text-sm text-stone-500">アルファイン</span>
                    <span className="text-sm text-stone-700 font-medium whitespace-nowrap">+¥3,000</span>
                  </div>
                  <div className="flex items-center justify-between py-2.5 border-b border-stone-100">
                    <span className="text-sm text-stone-500">池袋・五反田・錦糸町</span>
                    <span className="text-sm text-stone-700 font-medium whitespace-nowrap">+¥1,000</span>
                  </div>
                  <div className="flex items-center justify-between py-2.5 border-b border-stone-100">
                    <span className="text-sm text-stone-500">その他エリア</span>
                    <span className="text-sm text-stone-700 font-medium whitespace-nowrap">+¥1,000〜</span>
                  </div>
                </div>
                <p className="text-[10px] text-stone-400 mt-3">※上記以外のエリアはお気軽にご相談ください</p>
              </div>

            </div>
          </div>

          {/* おはなしコース — SPECIAL（コンパクト） */}
          <div data-section="talk-course" ref={talkRef} style={talkStyle} className="mx-auto w-full max-w-2xl bg-gradient-to-br from-rose-50 to-white border-2 border-rose-200 px-7 py-7 rounded-xl">
            <div className="flex items-center justify-between mb-5">
              <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-amber-400 to-yellow-500 text-white text-[11px] font-semibold tracking-[0.2em] px-3.5 py-1.5 rounded-full whitespace-nowrap">
                <i className="ri-vip-crown-2-fill text-xs leading-none"></i>
                SPECIAL
              </span>
              <span className="font-en text-xs tracking-[0.3em] text-amber-600 uppercase leading-none">Talk Course</span>
            </div>
            <p className="text-lg font-semibold text-stone-800 tracking-wide mb-4 whitespace-nowrap">おはなしコース <span className="text-sm font-normal text-stone-500">（カウンセリングセッション）</span></p>
            <p className="text-sm text-stone-600 leading-relaxed mb-6 max-w-xl">{talkCourse.description}</p>
            <div className="flex items-center justify-between bg-white border border-rose-100 rounded-lg px-5 py-4">
              <span className="text-sm text-stone-500 tracking-wide">{talkCourse.duration}</span>
              <span className="text-2xl text-stone-900 font-light tracking-wider">{talkCourse.price}</span>
            </div>
            <div className="mt-5 space-y-1.5 border-t border-rose-100 pt-4">
              {talkCourse.details.map((d, i) => (
                <p key={i} className="text-xs text-stone-500 leading-relaxed whitespace-nowrap">・{d}</p>
              ))}
            </div>
            <p className="text-xs text-stone-400 mt-4 pt-3 border-t border-rose-100">{talkCourse.disclaimer}</p>
          </div>

        </div>

      </div>
    </section>
  );
}